/* @flow */
import * as React from 'react';
import styles from './styles.module.scss';
import { withTranslation } from 'react-i18next';

import type { Translate } from 'types';

type Props = {
  t: Translate,
};

class ProductionIntro extends React.Component<Props, void> {
  render() {
    const { t } = this.props;
    return <div className={styles.container}>{t('PRODUCTION_DESCRIPTION')}</div>;
  }
}

export default withTranslation()(ProductionIntro);
